import { createSlice } from "@reduxjs/toolkit";
import { fetchFinalMissed } from "../../apis/dispense/finalMissed";

const initialState = {
	loading: false,
	data: null,
	error: null
}

const finalMissedListSlice = createSlice({
	name: 'fetchFinalMissed',
	initialState,

	extraReducers: (builder) => {
		builder.addCase(fetchFinalMissed.pending.type, (state) => {
			return {
				...state,
				loading: true,
				// data: null,
				error: null
			}
		})

		builder.addCase(fetchFinalMissed.fulfilled.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			}
		})

		builder.addCase(fetchFinalMissed.rejected.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: null,
				error: action.payload
			}
		})
	}

})

export default finalMissedListSlice.reducer